import { type ReactNode } from "react";

import { BdsIconCheck, BdsIconClock, BdsIconXCircle } from "@buildertrend/components";

import { ApprovalStatus } from "commonComponents/approvals/ApprovalViewer/ApprovalViewer.types";

export const getApproverStatusIcon = (status: ApprovalStatus): ReactNode | undefined => {
    switch (status) {
        case ApprovalStatus.Approved:
            return <BdsIconCheck />;
        case ApprovalStatus.Rejected:
            return <BdsIconXCircle />;
        case ApprovalStatus.Pending:
            return <BdsIconClock />;
        default:
            return undefined;
    }
};

export const getApproverStatusDisplayType = (status: ApprovalStatus) => {
    switch (status) {
        case ApprovalStatus.Approved:
            return "success";
        case ApprovalStatus.Rejected:
            return "danger";
        case ApprovalStatus.Pending:
            return "warning";
        default:
            return "default";
    }
};
